import styles from "./PreviewSkeleton.module.scss";

export default function PreviewSkeleton() {
  return (
    <>
      <div aria-hidden className={styles.main}>
        <div className={styles.skeletonLayoutSelector} />

        <ol className={styles.skeletonPages}>
          {Array(4)
            .fill("")
            .map((_, i) => (
              <li key={i} className={styles.skeletonPage} />
            ))}
        </ol>
      </div>

      <div className={styles.skeletonBottomBar} />
    </>
  );
}
